<template>
    <transition name="fade" v-if="showModal">
        <section class="mask">
            <section class="pop-modal">
                <img src="./error-modal-pic.png" alt="error" class="err-pic">
                <div class="err-line">
                    <svg class="err-icon" width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <circle id="point" fill="#FFA0A0" cx="10" cy="10" r="10"></circle>
                            <path d="M9,9 L9,4 C9,3.44771525 9.44771525,3 10,3 C10.5522847,3 11,3.44771525 11,4 L11,9 L16,9 C16.5522847,9 17,9.44771525 17,10 C17,10.5522847 16.5522847,11 16,11 L11,11 L11,16 C11,16.5522847 10.5522847,17 10,17 C9.44771525,17 9,16.5522847 9,16 L9,11 L4,11 C3.44771525,11 3,10.5522847 3,10 C3,9.44771525 3.44771525,9 4,9 L9,9 Z" id="Combined-Shape" fill="#FFFFFF" transform="translate(10.000000, 10.000000) rotate(45.000000) translate(-10.000000, -10.000000) "></path>
                        </g>
                    </svg>
                    <span>{{errMsg}}</span>
                </div>
                <div class="btn" @click="closeModal">{{$t('common.confirm')}}</div>
            </section>
        </section>
    </transition>
</template>

<script>
    export default {
        name: 'error',
        props: [
            'msg'
        ],
        data (){
            return {
                errMsg: this.$t('common.error'),
                showModal: true
            }
        },
        methods: {
            closeModal (){
                this.$emit('closeModal')
            }
        },
        created (){
            this.msg ? this.errMsg = this.msg : ''
        }
    
    }
</script>

<style lang="scss" scoped>
    .err-icon {
        margin-top: -2px;
        margin-right: 5px;
        vertical-align: middle;
    }
    .btn {
        font-size: .14rem;
        display: block;
        height: .4rem;
        line-height: .4rem;
        color: #fff;
        border-radius: .2rem;
        background-color: #50BBE5;
        transition: all .3s;
        cursor: pointer;
        &:hover {
            box-shadow: 0 4px 6px 0 rgba(10,131,186,0.3);
        }
    }
    .err-line {
        margin: 40px 0;
        line-height: 22px;
        font-size: 16px;
        color: #444;
    }
    .err-pic {
        width: 100%;
    }
    .pop-modal {
        margin-top: 2.2rem;
        margin-left: 50%;
        padding: .3rem .12rem;
        width: 3rem;
        height: 2.74rem;
        background-color: #fff;
        border-radius: .12rem;
        text-align: center;
        transform: translateX(-50%);
        box-sizing: border-box;
        overflow: hidden;
        font-size: 0;
    }
    .mask {
        position: fixed;
        z-index: 13;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .6);
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
        }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>


